import React, { ChangeEvent, useState } from 'react'
import { Icon } from '../Icon'

interface UIPasswordInputProps {
  label?: string
  value?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  autoCapitalize?: string | undefined
  error?: string | undefined
  iconName: string
  labelBottom?: string
  labelBottomList?: string[]
}

const UIPasswordInput: React.FC<UIPasswordInputProps> = ({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  iconName,
  labelBottom,
  labelBottomList,
}) => {
  const [isPasswordShow, setIsPasswordShow] = useState<boolean>(false)
  return (
    <div className="flex flex-col gap-2">
      <label
        className={`text-xs font-medium ${
          error ? 'text-textError' : 'text-text1'
        }`}
      >
        {label}
      </label>
      <div
        className={`w-fill h-auto p-3 border rounded-xl flex items-center gap-2 ${
          error ? 'border-textError' : 'border-gray3'
        }`}
      >
        {iconName && (
          <Icon
            name={iconName}
            width={16}
            height={16}
            strokeWidth={1}
            stroke={error ? '#FF6666' : '#02698C'}
          />
        )}
        <input
          type={isPasswordShow ? 'text' : 'password'}
          className={`w-full focus:outline-none text-sm font-normal  ${
            error
              ? 'placeholder-textError text-textError'
              : 'placeholder-text3 text-text4'
          }`}
          value={value || ''}
          onBlur={onBlur}
          onChange={onChange}
          placeholder={placeholder}
        />
        <div onClick={() => setIsPasswordShow(!isPasswordShow)}>
          <Icon
            name={isPasswordShow ? 'IconEye' : 'IconEyeOff'}
            width={16}
            height={16}
            strokeWidth={1}
            stroke={error ? '#FF6666' : '#02698C'}
          />
        </div>
      </div>
      {labelBottom && (
        <label
          className={`text-xs font-medium leading-5 ml-3 ${
            error ? 'text-textError' : 'text-text1'
          }`}
        >
          {labelBottom}
        </label>
      )}

      {labelBottomList &&
        labelBottomList?.map((item, index) => {
          return (
            <>
              <label
                key={index + 1}
                className={`text-xs font-medium leading-5 ml-3 ${
                  error ? 'text-textError' : 'text-text1'
                }`}
              >
                {index + 1}. {item}
              </label>
            </>
          )
        })}
    </div>
  )
}

export default UIPasswordInput
